import { Button } from '@vtbhome/juicyfront';
import { styled } from 'goober';

// Для сохранения ширины при отображении лоудера
export const RefreshButton = styled(Button)<{ isTimer: boolean }>`
    ${({ isTimer }) => !isTimer && 'min-width: 208px !important;'}
`;
